import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Line = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 20px;
`;

export const CheckboxRight = styled.input`
  margin-left: auto;
`;

export const ContentCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;
